module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/solocode-mapping/solocode-mapping.component.sass
// module id = ./src/app/modules/user/components/solocode-mapping/solocode-mapping.component.sass
// module chunks = main